import Component from '../abstracts/Component';

export default class ShowPasswordComponent extends Component {

  get SELECTORS() {
    return {
      main: '.toggle-password',
    };
  }

  get CLASSES() {
    return {
      passwordVisible: 'is-password-visible'
    };
  }

  constructor() {
    super();
  }

  bindEvents() {
    this.$on('click', ({event}) => {
      event.preventDefault();
      const btn = event.currentTarget;
      const input = event.currentTarget.parentElement.querySelector('input');
      const inputType = input.getAttribute('type');

      if (!input.value) return;

      switch (inputType) {
        case 'password':
          input.setAttribute('type', 'text');
          event.currentTarget.classList.add(this.CLASSES.passwordVisible);
          btn.setAttribute('aria-label', btn.dataset.labelHide);
          break;
        case 'text':
          input.setAttribute('type', 'password');
          event.currentTarget.classList.remove(this.CLASSES.passwordVisible);
          btn.setAttribute('aria-label', btn.dataset.labelShow);
          break;
      }
    }, 'body', this.SELECTORS.main);
  }

  render() {
    this.log("Rendering...")
    this.bindEvents();
  }
}
